import { render, staticRenderFns } from "./TotalUsageSummary.vue?vue&type=template&id=d2fa40e0&"
import script from "./TotalUsageSummary.vue?vue&type=script&lang=ts&"
export * from "./TotalUsageSummary.vue?vue&type=script&lang=ts&"
import style0 from "./TotalUsageSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
